import Component from '@glimmer/component';

import CButton from 'rise-ui/components/c-button.gjs';
import CIdentity from 'rise-ui/components/c-identity.gjs';
import concatClasses from 'rise-ui/helpers/concat-classes.js';

export default class DropdownListButtonButtonComponent extends Component {
  <template>
    <CButton
      @classMix={{@classMix}}
      @type={{concatClasses "select" @type}}
      @disabled={{@disabled}}
      @title={{@title}}
      @stopPropagation="false"
      ...attributes
      as | btn |
    >
      <btn.default>{{yield (component CIdentity)}}</btn.default>
    </CButton>
  </template>
}
